/**
 * 服务端接口封装
 */

import RQ from './request.js'
import utils from './utils.js'

const CONFIG = {
  IS_DEV: false,
  SERVER: '/',
  DEV_SERVER: '/',
  STATICDOMAIN: 'http://otq0t8ph7.bkt.clouddn.com/', // 七牛图片服务器的域名，展示时使用
  STATVIDEO: 'http://otq0t8ph7.bkt.clouddn.com/', // 七牛上传域名
  QINIU_TOKEN_G: 'https://mp.umier.cn/file/qiniu/uploadToken', // 获取七牛上传token
  //QINIU_TOKEN_G: 'http://dev.mp.umier.cn/file/qiniu/uploadToken', // 获取七牛上传token
  QINIU_GETURL: 'https://mp.umier.cn/file/qiniu/privateDownloadUrl',
  //QINIU_GETURL: 'http://dev.mp.umier.cn/file/qiniu/privateDownloadUrl',
  QINIU_GETURLS: 'https://mp.umier.cn/file/qiniu/privateDownloadUrls',
  //QINIU_GETURLS: 'http://dev.mp.umier.cn/file/qiniu/privateDownloadUrls',
  APPID: 'zhishu', // 开发平台相应的APPID
  APIS: {

    ADMIN_LOGIN_CHECK: 'validate', // 登录校验

    COLUMN_Q: 'admin/media/list/query', // 专栏查`询
    COLUMN_G: 'admin/media/list/get', // 获取某个专栏
    COLUMN_U: 'admin/media/list/update', // 更新专栏
    COLUMN_D: 'admin/media/list/delete', // 更新专栏
    COLUMN_US: 'admin/media/list/updateStatus', // 更新专栏状态
    COLUMN_C: 'admin/media/list/add', // 創建专栏
    COLUMN_SI: 'admin/media/list/saveItem', // 添加专栏数据
    CONTENT_UPDATESORT: 'admin/media/list/sortItem', // 更新排序
    COLUMN_DI: 'admin/media/list/deleteItem', // 从专栏删除某个视频
    CONTENT_Q: 'admin/media/data/query', // 查询视频列表
    CONTENT_G: 'admin/media/data/get', // 获取某个视频内容
    CONTENT_U: 'admin/media/data/update', // 更新视频
    CONTENT_US: 'admin/media/data/updateStatus', // 更新专栏内容状态
    CONTENT_C: 'admin/media/data/add', // 創建视频
    CONTENT_D: 'admin/media/data/delete', // 創建视频

    AUDIT_COLUMN: "admin/media/list/audit", //專欄审核
    AUDIT_CONTENT: "admin/media/data/audit", //電子資源审核

    CLASS_Q: 'admin/cms/class/query', // 查询分类
    CLASS_C: 'admin/cms/class/add', // 添加分类
    CLASS_U: 'admin/cms/class/update', // 更新分类
    CLASS_D: 'admin/cms/class/delete', // 删除分类
    CLASS_SAVE: 'admin/cms/class/save', // 分类保存
    CLASS_GET: 'admin/cms/class/getTree',//获取分類列表
    CLASS_PAGE_TREE: 'admin/cms/class/pageTree',//获取分類樹分頁查詢
    CLASS_PAGE_BATCH: 'admin/cms/class/saveBatch',//批量修改分类

    COLUMN_SETCLASS: 'admin/media/list/setClass', // 设置分类
    COLUMN_SETTAG: 'admin/media/list/setTag', // 设置分类
    TAG_Q: 'admin/cms/tag/query', // 查询标签
    TAG_Q_BY_CATE: 'admin/cms/tag/queryGroupByCategory',
    TAG_C: 'admin/cms/tag/add', // 添加标签
    TAG_U: 'admin/cms/tag/update', // 更新标签
    TAG_D: 'admin/cms/tag/delete', // 删除标签

    ORDER_LIST: 'admin/media/order/queryBuyList', // 查询用户购买记录
    GROUPBUY_LIST: 'admin/media/order/queryGroupBuyList', // 查询用户团购记录
    UPDATE_GROUPBUY_STATUS: 'admin/media/order/queryGroupBuyResult', // 更新团购记录
    GET_GROUPBUY_DETAIL: 'admin/media/order/getGroupBuy',

    MEDIA_DATA_REPORT: 'admin/media/report/query', // 查询数据报告
    MEDIA_DATA_DETAIL: 'admin/media/report/queryDetail', // 查询数据明细

    GROUPBUY_DATA: 'admin/sale/groupBuy/queryStat',
    OEDER_DATA: 'admin/sale/order/queryStat',
    USER_DATA: 'admin/user/queryStat'

  },
  BLOCK_APIS: {
    BLOCK_LIST: '/block/list', // 区块列表
    BLOCK_GET: '/block/get', // 区块详情
    BLOCK_UPDATE: '/block/update', // 更新区块
    BLOCK_ADD: '/block/add', // 添加区块
    BLOCK_DELETE: '/block/delete', // 删除区块
    BLOCK_FREEZE: '/block/freeze', // 禁用
    BLOCK_UFREEZE: '/block/unfreeze', // 启用
    LIST_LIST: '/blockList/list', // 清单列表
    LIST_GET: '/blockList/get', // 清单详情
    LIST_UPDATE: '/blockList/update', // 清单更新
    LIST_ADD: '/blockList/add', // 添加清单
    LIST_DELETE: '/blockList/delete', // 删除清单
    LIST_DISABLE: '/blockList/disable', // 禁用
    LIST_ENABLE: '/blockList/enable', // 启用
    LIST_SETTOP: '/blockList/setTop', // 置顶
    ITEM_LIST: '/blockListItem/list', // 条目列表
    ITEM_GET: '/blockListItem/get', // 条目详情
    ITEM_UPDATE: '/blockListItem/update', // 更新条目
    ITEM_ADD: '/blockListItem/add', // 創建条目
    ITEM_DELETE: '/blockListItem/delete', // 删除清单
    ITEM_FREEZE: '/blockListItem/freeze', // 禁用
    ITEM_UNFREEZE: '/blockListItem/unfreeze', // 启用
    ITEM_SETTOP: '/blockListItem/setTop' // 置顶
  },
  COMMENT_APIS: {
    BUSINESS_TYPE: 'medialist', // 评论类型
    LIST: 'admin/media/comment/query', // 评论列表
    REPLY_LIST: 'admin/comment/queryReplyList', // 评论回复列表
    GET_TOP: 'admin/comment/getTop', // 获取置顶评论
    SET_TOP: 'admin/comment/setTop', // 设置置顶
    DELETE: 'admin/comment/delete', // 删除评论，物理删除
    UPDATE: 'admin/comment/update', // 更新评论
    UPDATE_STATUS: 'admin/comment/updateStatus', // 更新评论状态 0待审核，1已审核，2已删除
    SET_CHOSEN: "admin/comment/setChoice", // 设置精選
    SCREENUSER: "admin/comment/user/add", //屏蔽用戶
    SCREENUSERLIST: "admin/comment/user/query" //屏蔽用戶列表
  },
  USER_APIS: {
    LIST: 'admin/user/query', // 列表
    GET: 'admin/user/getUserInfo', // 列表
    UPDATE_STATUS: 'admin/user/updateUserStatus', // 列表
    SEARCH_USER: '/admin/user/search_user'
  },


  INVITECODE_APIS: {
    LIST: 'admin/sale/inviteCode/query',
    GENERATE: 'admin/sale/inviteCode/generate', // 生成
    DELETE: 'admin/sale/inviteCode/delete'

  },

  COLUMNADMIN_APIS: {
    LIST: "admin/cms/column/list",
    SAVE: "admin/cms/column/save",
    DELETE: "admin/cms/column/delete",
    QUERY: "admin/cms/column/query",
    UPDATESORT: "admin/cms/column/updateSortOrder"
  },


  SALE_ACTIVITY: {
    QUERY: "admin/sale/activity/query"
  },

  PROMOTION_ACTIVITY: {
    QUERY: "admin/activity/info/query"

  }
}

function getServer() {
  return CONFIG.IS_DEV ? CONFIG.DEV_SERVER : CONFIG.SERVER
}

function d(api, paramams) {
 // console.log('paramams: ', paramams);

  let url = getServer() + api
  paramams = utils.filterUndefined(paramams)
  return RQ.request(url, 'POST', null, paramams)
}

function d2(api, paramams) {
  return RQ.request(api, 'POST', null, paramams)
}

export default {
  CONFIG,
  d,
  d2
}